import script from "./EditCouponForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCouponForm.vue?vue&type=script&setup=true&lang=js"

import "./EditCouponForm.vue?vue&type=style&index=0&id=3ed35258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed35258"]])

export default __exports__